module.exports = __webpack_public_path__ + "static/media/cerevisiae_heatshock.bb494db0.png";